import "@babel/polyfill";
import ChartLoader from "./components/ChartLoader";
import ChartPro from "./components/ChartPro";
import Creator from "./components/Creator";
import MediaWidget from "./components/MediaWidget";
import qs from "qs";

var elements = document.querySelectorAll(".root");
[...elements].forEach(element => {
  ReactDOM.render(
    <ChartLoader
      ticker={window.ticker}
      listingID={window.listingID}
      lineColor={window.lineColor}
      axisColor={window.axisColor}
      bgColor={window.bgColor}
      days={window.days}
      padding={window.padding}
    />,
    element
  );
});

var elements = document.querySelectorAll("#creator");
[...elements].forEach(element => {
  ReactDOM.render(<Creator />, element);
});

var elements = document.querySelectorAll(".MediaPlayer");
[...elements].forEach(element => {
  ReactDOM.render(
    <MediaWidget
      ticker={element.dataset.ticker}
      mediaID={element.dataset.mediaid}
      mediaType={element.dataset.mediatype}
      color={element.dataset.color}
      bg={element.dataset.bg}
      playerWidth={element.dataset.playerWidth}
      type={element.dataset.type}
    />,
    element
  );
});

const search = qs.parse(window.location.search, {
  ignoreQueryPrefix: true
});
var elements = document.querySelectorAll("#chart2");
[...elements].forEach(element => {
  ReactDOM.render(<ChartPro {...search} />, element);
});
